module.exports = __webpack_public_path__ + "img/newcastle.a48d434c.jpg";